export default __webpack_public_path__ + "static/logocombiphar-dd93965e94d64c77f9908602d4f18e69.png";